import config from "config/config";

export const isWholeLifePolicy = (policyType) => {
  const WHOLE_LIFE_PRODUCT_CODE = config.WHOLE_LIFE_PRODUCT_CODE?.split(",");

  if (!policyType || typeof policyType !== "string") return false;
  return WHOLE_LIFE_PRODUCT_CODE.includes(policyType.trim().toUpperCase());
};
